import React from 'react';

import Container from '@material-ui/core/Container';

export default (props) => {
  return (
    <>
      <header className="header">
        <img src={process.env.PUBLIC_URL + '/ausbiz.png'} alt="ausbiz" />
      </header>
      <Container>
        <div className="loading">
          <h3>{ props.message }</h3>
        </div>
      </Container>
    </>
  );
};